import './types';

/**
 * @param {StatsLeadersState} draft - Draft state.
 * @param {StatsLeadersSortState} payload - Action payload.
 */
export const setSort = ( draft, payload ) => {
    draft.sort = {
        ...draft.sort,
        ...payload
    };
};